<script>
export default {
    name: "TableLoadState",
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        startTableLoading() {
            if (this.isLoading) return false;

            this.isLoading = true;

            return true;
        },
        stopTableLoading() {
            this.isLoading = false;
        },
        emitTableLoadError(error) {
            console.error('Error loading table data:', error);
            this.$emit('load-error', error);
        },
    },
}
</script>
